import ArticleGuides from './articleGuides'

const guidesContainer = document.querySelector('.articleGuides')

if (guidesContainer) {
	const articleGuides = new ArticleGuides()
	articleGuides.init()
}
